@switch (mode()) {
  @case ('multi') {
    <div class="flex items-center gap-2">
      @if (selectionCount() > 0) {
        <span class="ds-caption value-input-count">{{ selectionCount() }} {{ '#CORE_FILTER.CUSTOM.SELECTED' | translate }}</span>
      }
      <soft-ds-button variant="ghost" size="md"
                      (click)="editValues.emit()"
                      data-testid="filter-value-edit">
        {{ '#CORE_FILTER.CUSTOM.EDIT_VALUES' | translate }}
      </soft-ds-button>
    </div>
  }
  @case ('text') {
    <soft-ds-input [value]="textValue()"
                   size="md"
                   [placeholder]="'#CORE_FILTER.CUSTOM.VALUE' | translate"
                   (valueChange)="valueChange.emit($event)"
                   data-testid="filter-value-text">
    </soft-ds-input>
  }
  @case ('number') {
    <soft-ds-number-input [value]="numberValue()"
                          size="md"
                          (valueChange)="valueChange.emit($event)"
                          data-testid="filter-value-number">
    </soft-ds-number-input>
  }
  @case ('number-range') {
    <div class="flex items-center gap-2">
      <soft-ds-number-input [value]="rangeValue().from"
                            size="md"
                            [placeholder]="'#CORE_FILTER.CUSTOM.FROM' | translate"
                            (valueChange)="onRangeChange('from', $event)"
                            data-testid="filter-value-range-from">
      </soft-ds-number-input>
      <soft-ds-number-input [value]="rangeValue().to"
                            size="md"
                            [placeholder]="'#CORE_FILTER.CUSTOM.TO' | translate"
                            (valueChange)="onRangeChange('to', $event)"
                            data-testid="filter-value-range-to">
      </soft-ds-number-input>
    </div>
  }
  @case ('date') {
    <soft-ds-date-input [value]="dateValue()"
                        size="md"
                        (valueChange)="valueChange.emit($event)"
                        data-testid="filter-value-date">
    </soft-ds-date-input>
  }
  @case ('date-range') {
    <div class="flex items-center gap-2">
      <soft-ds-date-input [value]="rangeValue().from"
                          size="md"
                          (valueChange)="onRangeChange('from', $event)"
                          data-testid="filter-value-date-from">
      </soft-ds-date-input>
      <soft-ds-date-input [value]="rangeValue().to"
                          size="md"
                          (valueChange)="onRangeChange('to', $event)"
                          data-testid="filter-value-date-to">
      </soft-ds-date-input>
    </div>
  }
}
